import { Check } from 'lucide-react';
import { Typography } from './Typography';
import { Badge } from './Badge';
import { Button } from './Button';
import styles from './EngagementCard.module.css';
export function EngagementCard({
  title,
  description,
  features,
  featured = false,
}: {
  title: string;
  description: string;
  features: string[];
  featured?: boolean;
}) {
  return (
    <article className={`${styles.card} ${featured ? styles.featured : ''}`}>
      <div className={styles.top}>
        <Typography as="h3" variant="subheading" tone="inherit">
          {title}
        </Typography>
        <Badge>{featured ? 'Полный цикл' : 'Под вашу задачу'}</Badge>
      </div>
      <Typography tone="inherit">{description}</Typography>
      <div className={styles.price}>
        <Typography variant="quote" tone="inherit">
          Индивидуальное КП
        </Typography>
        <Typography variant="small" tone="inherit">
          После оценки объёма работ
        </Typography>
      </div>
      <Button href="/contact/" fullWidth variant={featured ? 'light' : 'primary'}>
        Обсудить условия
      </Button>
      <ul>
        {features.map((x) => (
          <li key={x}>
            <Check size={16} aria-hidden />
            <Typography variant="small" tone="inherit">
              {x}
            </Typography>
          </li>
        ))}
      </ul>
    </article>
  );
}
